var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-card32-gallery-card",class:_vm.rootClassName},[_c('img',{staticClass:"gallery-card32-image",attrs:{"alt":_vm.imageAlt,"src":_vm.imageSrc}}),_c('div',{staticClass:"gallery-card32-container"},[_c('h1',{staticClass:"gallery-card32-text1"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }